import React, { useState } from "react";
import toast from "react-hot-toast";
import { MdVerified, MdVerifiedUser } from "react-icons/md";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { PhotoProvider, PhotoView } from "react-photo-view";
import useVerifiedSeller from "../../../../hooks/useVerifiedSeller";
import { BeatLoader } from "react-spinners";
import { TypeAnimation } from "react-type-animation";

const AndroidPhone = ({
  androidPhone,
  setPhone,
  currentUser,
  currentBuyer,
}) => {
  // console.log("androidPhone:", androidPhone);
  const {
    _id,
    postedDate,
    postedTime,
    productImg,
    productName,
    brand,
    model,
    category,
    description,
    yearsOfUse,
    conditionType,
    resalePrice,
    originalPrice,
    sellerName,
    sellerMobile,
    sellerEmail,
    sellingReason,
    salesStatus,
    isBooked,
    location,
  } = androidPhone;

  const [isVerifiedSeller, isSellerLoading] = useVerifiedSeller(sellerEmail);

  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const handleBooked = (isBooked, productName) => {
    if (isBooked) {
      toast.error(`"${productName}" has Booked already`);
    }
  };

  const handleSoldOut = (salesStatus, productName) => {
    if (salesStatus === "sold") {
      toast.error(`Sorry! This "${productName}" has been Sold out`);
    }
  };

  const handleReportToAdmin = (androidPhone) => {
    saveReportedItemToDb(androidPhone);
  };

  const handleAddWishlist = (androidPhone) => {
    if (currentUser?.role === "buyer") {
      addWishlistItemToDb(androidPhone);
    } else {
      toast.error(
        "Only Buyers can add phones to Wishlist. Please create a 'Buyer' account first!"
      );
      return;
    }
  };

  const saveReportedItemToDb = (androidPhone) => {
    const { productName, productImg, category, sellerName } = androidPhone;
    const reportedItem = {
      productId: _id,
      productName,
      productImg,
      category,
      sellerName,
      ReportedBy: currentUser?.name,
      email: currentUser?.email,
      role: currentUser?.role,
    };

    setLoading1(true);

    fetch("https://recycle-hut-server.vercel.app/reported-items", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(reportedItem),
    })
      .then((res) => res.json())
      .then((data) => {
        // console.log("save reportedItem", data);

        if (data.acknowledged) {
          toast.success(
            `"${androidPhone.productName}" is marked as a Reported phone`
          );

          setLoading1(false);
        } else {
          toast.error(data.message);
          setLoading1(false);
        }
      });
  };

  const addWishlistItemToDb = (androidPhone) => {
    const {
      productName,
      productImg,
      category,
      resalePrice,
      sellerName,
      location,
    } = androidPhone;

    const wishListItem = {
      productId: androidPhone._id,
      productName,
      productImg,
      category,
      resalePrice,
      sellerName,
      sellerlocation: location,
      buyerName: currentBuyer?.name,
      buyerEmail: currentBuyer?.email,
    };

    setLoading2(true);

    fetch("https://recycle-hut-server.vercel.app/wishlist-items", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(wishListItem),
    })
      .then((res) => res.json())
      .then((data) => {
        // console.log("save wishlist item", data);

        if (data.acknowledged) {
          toast.success(
            `"${androidPhone.productName}" is successfully added to your Wislist`
          );
          setLoading2(false);
        } else {
          toast.error(data.message);
          setLoading2(false);
        }
      });
  };

  return (
    <div
      className="common card md:card-side bg-base-100 shadow-2xl w-[90%] md:w-[85%]  lg:w-[72%] mx-auto gap-5 md:gap-0"
      data-aos="fade-up"
      data-aos-duration="1500"
    >
      <div className="flex flex-col justify-center items-center bg-[aliceblue] rounded-xl shadow-sm md:shadow-none">
        {salesStatus === "sold" ? (
          <div className="hover:cursor-not-allowed mt-10 -mb-2 md:mb-5 border-[1px] border-red-500 px-3 py-1 rounded-[7px]">
            <span className="text-red-500 font-extrabold text-[16px]  md:text-[20px] uppercase">
              Not Available
            </span>
          </div>
        ) : (
          <></>
        )}

        <div>
          <PhotoProvider
            speed={() => 800}
            easing={(type) =>
              type === 2
                ? "cubic-bezier(0.36, 0, 0.66, -0.56)"
                : "cubic-bezier(0.34, 1.56, 0.64, 1)"
            }
          >
            <PhotoView src={productImg}>
              <figure>
                <LazyLoadImage
                  src={productImg}
                  alt={productName}
                  className="w-full lg:w-[420px] h-[300px] lg:h-[420px] rounded-xl px-0 py-8 md:p-10 md:pb-10 my-transition-1"
                  placeholderSrc={productImg}
                  effect="blur"
                  title="Click to see the full size photo"
                  style={{ objectFit: "cover", cursor: "pointer" }}
                />
              </figure>
            </PhotoView>
          </PhotoProvider>
        </div>
      </div>

      <div className="card-body flex justify-between w-full md:w-[50%] rounded-xl my-transition-3">
        <div className="">
          <div className="card-title font-bold text-2xl mb-3 text-cyan-500 flex flex-col-reverse md:flex-row justify-between">
            <h2
              title="Phone Name"
              className="mt-[-5px] md:mt-[-3px] hover:font-mon
            hover:text-[25px] my-transition-4"
            >
              <TypeAnimation
                sequence={[`${productName}`, 3000]}
                speed={30}
                cursor={false}
                repeat={Infinity}
              />
            </h2>
            <div
              className={
                isVerifiedSeller
                  ? "mt-[-25px] mb-4 md:m-0"
                  : "mt-[-100px] mb-16 md:mb-4 md:mt-[25px]"
              }
            >
              {isSellerLoading ? (
                <div className="text-white px-3 py-3 mt-[70px] md:mt-[-35px] rounded-full">
                  <BeatLoader color="#00cf00" size="12" speedMultiplier=".6" />
                </div>
              ) : (
                <div>
                  {isVerifiedSeller ? (
                    <div
                      className="flex items-center justify-center gap-2 bg-green-500 text-white px-3 py-1 rounded-xl md:rounded-lg shadow-lg md:hover:rounded-full hover:px-[15px]"
                      title="Verified Phone"
                    >
                      <span className="text-[20px]">Verified</span>
                      <span>
                        <MdVerifiedUser className="w-6 h-6"></MdVerifiedUser>
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        <p>
          <span className="font-semibold">Phone Brand:</span> {brand}
        </p>
        <p>
          <span className="font-semibold">Phone Model:</span> {model}
        </p>
        <p>
          <span className="font-semibold">Category:</span> {category}
        </p>
        <p>
          <span className="font-semibold">Condition Type:</span> {conditionType}
        </p>
        <p>
          <span className="font-semibold">Years of Used:</span>
          {yearsOfUse <= 1 ? (
            <span> {yearsOfUse} Year</span>
          ) : (
            <span> {yearsOfUse} Years</span>
          )}
        </p>
        <p>
          <span className="font-semibold">Selling Price:</span> {resalePrice}
          <span className="mr-1"> Tk</span>
        </p>

        <p>
          <span className="font-semibold">Buying Price:</span> {originalPrice}
          <span className="mr-1"> Tk</span>
        </p>

        <p>
          <span className="font-semibold">Posted Date:</span> {postedDate}
        </p>
        <p>
          <span className="font-semibold">Posted Time:</span> {postedTime}
        </p>

        {isVerifiedSeller ? (
          <p className="flex flex-row gap-x-2">
            <span className="font-semibold">Seller Name:</span>
            <span title="Verified Seller">{sellerName}</span>
            <span className="ml-[-2px]" title="Verified Seller">
              <MdVerified className="w-6 h-6 text-green-500 font-bold hover:text-blue-500" />
            </span>
          </p>
        ) : (
          <p>
            <span className="font-semibold mr-1">Seller Name:</span>
            {sellerName}
          </p>
        )}

        <p>
          <span className="font-semibold">Seller Mobile:</span> {sellerMobile}
        </p>

        <p>
          <span className="font-semibold"> Seller Location:</span> {location}
        </p>

        <p>
          <span className="font-semibold">Seller Email:</span> {sellerEmail}
        </p>

        <p className="w-full md:w-[90%] md:text-justify">
          <span className="font-semibold">Selling Reason:</span> {sellingReason}
        </p>

        <p className="w-full md:w-[90%] md:text-justify">
          <span className="font-semibold">Phone Details:</span> {description}
        </p>

        <div className="card-actions mt-4 flex items-center lg:justify-between">
          <div>
            {isBooked ? (
              <div>
                {salesStatus === "sold" ? (
                  <button
                    className="btn btn-accent bg-gray-400 hover:bg-gray-400 hover:cursor-not-allowed text-white border-none rounded-xl opacity-75"
                    disable="true"
                  >
                    Add To Wishlist
                  </button>
                ) : (
                  <button
                    className="btn btn-accent bg-gray-400 hover:bg-gray-400 hover:cursor-not-allowed text-white border-none rounded-xl opacity-75"
                    disable="true"
                  >
                    Add To Wishlist
                  </button>
                )}
              </div>
            ) : (
              <div>
                {salesStatus === "sold" ? (
                  <button
                    className="btn btn-accent bg-gray-400 hover:bg-gray-400 hover:cursor-not-allowed text-white border-none rounded-xl opacity-75"
                    disable="true"
                  >
                    Add To Wishlist
                  </button>
                ) : (
                  <button
                    className="btn btn-outline btn-primary opacity-80  text-white rounded-xl hover:rounded-full"
                    onClick={() => handleAddWishlist(androidPhone)}
                  >
                    {loading2 ? (
                      <BeatLoader color="red" size="11" speedMultiplier=".6" />
                    ) : (
                      "Add To Wishlist"
                    )}
                  </button>
                )}
              </div>
            )}
          </div>

          <div>
            {salesStatus === "sold" ? (
              <button
                className="btn btn-accent bg-gray-400 hover:bg-gray-400 hover:cursor-not-allowed text-white border-none rounded-xl opacity-75"
                disable="true"
              >
                Report This Phone
              </button>
            ) : (
              <button
                className="btn btn-outline btn-secondary rounded-xl hover:rounded-full hover:bg-red-500"
                value="Report This Phone"
                onClick={() => handleReportToAdmin(androidPhone)}
              >
                {loading1 ? (
                  <BeatLoader color="red" size="11" speedMultiplier=".6" />
                ) : (
                  "Report This Phone"
                )}
              </button>
            )}
          </div>

          <div>
            {isBooked ? (
              <div>
                {salesStatus === "sold" ? (
                  <button
                    className="btn btn-accent bg-gray-400 hover:bg-gray-400 hover:cursor-default text-white border-none rounded-xl opacity-75"
                    disable="true"
                    onClick={() => handleSoldOut(salesStatus, productName)}
                  >
                    Sold Out
                  </button>
                ) : (
                  <button
                    className="btn btn-accent bg-gray-400 hover:bg-gray-400 hover:cursor-default text-white border-none rounded-xl opacity-75"
                    disable="true"
                    onClick={() => handleBooked(isBooked, productName)}
                  >
                    Booked
                  </button>
                )}
              </div>
            ) : (
              <div>
                {salesStatus === "sold" ? (
                  <button
                    className="btn btn-accent bg-gray-400 hover:bg-gray-400 hover:cursor-default text-white border-none rounded-xl opacity-75"
                    disable="true"
                    onClick={() => handleSoldOut(salesStatus, productName)}
                  >
                    Sold Out
                  </button>
                ) : (
                  <label
                    htmlFor="booking-modal"
                    className="btn btn-accent bg-cyan-600 text-white rounded-xl hover:rounded-full"
                    onClick={() => setPhone(androidPhone)}
                  >
                    Book Now
                  </label>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AndroidPhone;
